<template>
  <div id="app" :class="[ isEng?'en':'']">

    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {}
    },
    computed: {
      isEng: function () {
        let isEn = this.$i18n.locale == 'en-US';
        if (isEn) {
          //$('html').attr('lang', 'en-US');
        } else {
          //$('html').attr('lang', '');
        }
        return isEn;
      }
    },
    mounted: function () {
      let lang = this.$store.state.lang || 'zh-TCC';
      //lang = 'en-US'
      this.$store.commit('setlang', lang);
      this.$i18n.locale = lang;
    }
  }
</script>

<style>
  /* @import './common/font/font.css'; */

  #app {
    font-family: 'Microsoft JhengHei', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0 0;
    padding: 0 0;
    min-height: 100%;
    min-width: 800px !important;

  }

  ::selection {
    background: #9bd9dd;
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue